import React from 'react';
import { shape, string, func, object, any, bool } from 'prop-types';
import FormikField from './FormikField';

import UploadButton from '../UploadButton';

const FormikUploadButton = ({ field, form, showNoError, ...other }) => {
  const fileHandler = (e) => {
    e.preventDefault();
    const { files } = e.target;
    if (files && files.length > 0) {
      const filesArray = form.values[field.name] || [];
      for (let i = 0; i < files.length; ++i) {
        filesArray.push(files[i]);
      }

      form.setFieldValue(field.name, filesArray);
      form.setTouched({ [field.name]: true });
      e.target.value = '';
    }
  };

  return (
    <FormikField field={field} form={form} showNoError={showNoError}>
      <UploadButton onChange={fileHandler} {...other} />
    </FormikField>
  );
};

FormikUploadButton.propTypes = {
  field: shape({
    name: string,
    value: any,
  }).isRequired,
  form: shape({
    errors: object,
    setFieldError: func,
    setFieldValue: func,
  }).isRequired,
  other: object,
  showNoError: bool,
};

FormikUploadButton.defaultProps = {
  other: {},
  showNoError: false,
};

export default FormikUploadButton;
